import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "userSwitch"
const UserSwitchIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path d="M12 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8ZM12 14c.705 0 1.388.046 2.039.131l-.003.005-.114.114.023.024A5.973 5.973 0 0 0 13 17.5c0 .892.195 1.739.544 2.5H4v-2c0-2.21 3.58-4 8-4ZM16.75 14.25 19 12v1.5c2.21 0 4 1.79 4 4 0 .82-.25 1.58-.67 2.21l-1.09-1.09c.17-.34.26-.72.26-1.12A2.5 2.5 0 0 0 19 15v1.5l-2.25-2.25ZM15 17.5c0-.82.25-1.58.67-2.21l1.09 1.09c-.17.34-.26.72-.26 1.12A2.5 2.5 0 0 0 19 20v-1.5l2.25 2.25L19 23v-1.5c-2.21 0-4-1.79-4-4Z" />
        </svg>
      }
    </span>
  )
}
export default UserSwitchIcon
